// OPERATION API
import Request from '../base'
export default {
    save (options) {
        return Request.post('/ebermain/mainapi/aims/operation/save', options)
    },
    delete (options) {
        return Request.post('/ebermain/mainapi/aims/operation/delete', options)
    },
    load (options) {
        return Request.post('/ebermain/mainapi/aims/operation/load', options)
    },
    list (options) {
        return Request.post('/ebermain/mainapi/aims/operation/list', options)
    },
    find (pagination, options) {
        var ps = {}
        if (pagination) {
            ps.sort = pagination.sort || 'arrangedStartTime'
            ps.order = pagination.order || 'DESC'
            ps.pageOffset = pagination.current || 1
            ps.pageSize = pagination.size || 10
        }
        for (var k in options) {
            if (options[k]) {
                ps[k] = options[k]
            }
        }
        return Request.post('/ebermain/mainapi/aims/operation/find', ps)
    },
    count (options) {
        return Request.post('/ebermain/mainapi/aims/operation/count', options)
    },
    approve (options) {
        return Request.post('/ebermain/mainapi/aims/operation/approve', options)
    },
    back (options) {
        return Request.post('/ebermain/mainapi/aims/operation/back', options)
    },
    updateDate (options) {
        return Request.post('/ebermain/mainapi/aims/operation/updateDate', options)
    },
    arrange (options) {
        return Request.post('/ebermain/mainapi/aims/operation/arrange', options)
    },
    cancel (options) {
        return Request.post('/ebermain/mainapi/aims/operation/cancel', options)
    },
    release (options) {
        return Request.post('/ebermain/mainapi/aims/operation/release', options)
    },
    participator (options) {
        return Request.post('/ebermain/mainapi/aims/operation/participator', options)
    },
    export (pagination, options) {
        if (!pagination.sort) {
            pagination.sort = 'arrangedStartTime'
        }
        if (!pagination.order) {
            pagination.order = 'DESC'
        }
        Request.download('/ebermain/mainapi/aims/operation/export', Request.paginationBody(options, pagination))
    }
}
